import { observable, action, runInAction } from 'mobx';
import { RootStore } from '..';
import { fetchWrapper } from '../../common/Fetch';
import { formatDateJson } from '../../common/Formatting';

export interface Report1Data {
    items: Report1Item[];
    totals: Report1ItemManager[]
}


export interface Report1Item {
    date: Date;
    managers: Report1ItemManager[]
}

export interface Report1ItemManager {
    managerId: string;
    managerName: string;
    ordersCount: number;
    positionsCount: number;
    sum: number
}

export class Report1Store {

    _rootStore: RootStore;

    @observable items: Report1Item[] = [];
    @observable totals: Report1ItemManager[] = [];


    constructor(rootStore: RootStore) {
        this._rootStore = rootStore;
    }


    @action
    loadData(managerIds: string[], sources: string[], statuses: number[], dateFrom?: Date, dateTo?: Date) {
        this.items = [];
        const managerIdsParam = managerIds.length <= 0 ? "" : "&managerIds=" + managerIds.join("&managerIds=");
        const sourcesParam = sources.length <= 0 ? "" : "&sources=" + sources.join("&sources=");
        const statusesParam = statuses.length <= 0 ? "" : "&statuses=" + statuses.join("&statuses=");
        const dateFromStr = dateFrom == undefined ? '' : formatDateJson(dateFrom);
        const dateToStr = dateTo == undefined ? '' : formatDateJson(dateTo);

        fetchWrapper(`api/report1/getdata?dateFrom=${dateFromStr}&dateTo=${dateToStr}${managerIdsParam}${sourcesParam}${statusesParam}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }, this._rootStore.commonStore)
            .then(res => res.json() as Promise<Report1Data>)
            .then(result => {
                runInAction("fetch complete loadData", () => {
                    this.items = result.items;
                    this.totals = result.totals;
                });
            })
            .catch(res => {
                console.log(res);
            });
    }

}